<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import ContactIdentityBand from 'dashboard/components-next/Contacts/ContactsDetails/ContactIdentityBand.vue';
import ContactAboutCard from 'dashboard/components-next/Contacts/ContactsDetails/ContactAboutCard.vue';
import ContactQualificationCard from 'dashboard/components-next/Contacts/ContactsDetails/ContactQualificationCard.vue';
import ContactTripsCard from 'dashboard/components-next/Contacts/ContactsDetails/ContactTripsCard.vue';
import ContactActivityCard from 'dashboard/components-next/Contacts/ContactsDetails/ContactActivityCard.vue';

const props = defineProps({
  selectedContact: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();

const avatarUrl = ref('');

const avatarSrc = computed(
  () => avatarUrl.value || props.selectedContact?.thumbnail || ''
);

const handleAvatarUpload = async ({ file, url }) => {
  avatarUrl.value = url;

  try {
    await store.dispatch('contacts/update', {
      id: props.selectedContact.id,
      avatar: file,
      // empty socialProfiles keeps buildContactFormData's shape expectations
      additionalAttributes: { socialProfiles: {} },
      isFormData: true,
    });
    useAlert(t('CONTACTS_LAYOUT.DETAILS.AVATAR.UPLOAD.SUCCESS_MESSAGE'));
  } catch {
    avatarUrl.value = '';
    useAlert(t('CONTACTS_LAYOUT.DETAILS.AVATAR.UPLOAD.ERROR_MESSAGE'));
  }
};

const handleAvatarDelete = async () => {
  try {
    if (props.selectedContact?.id) {
      await store.dispatch('contacts/deleteAvatar', props.selectedContact.id);
      useAlert(t('CONTACTS_LAYOUT.DETAILS.AVATAR.DELETE.SUCCESS_MESSAGE'));
    }
    avatarUrl.value = '';
  } catch (error) {
    useAlert(
      error.message
        ? error.message
        : t('CONTACTS_LAYOUT.DETAILS.AVATAR.DELETE.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <div class="flex flex-col w-full gap-4">
    <ContactIdentityBand
      :selected-contact="selectedContact"
      :avatar-src="avatarSrc"
      @upload-avatar="handleAvatarUpload"
      @delete-avatar="handleAvatarDelete"
    />
    <ContactAboutCard :selected-contact="selectedContact" />
    <ContactQualificationCard :selected-contact="selectedContact" />
    <ContactTripsCard :selected-contact="selectedContact" />
    <ContactActivityCard :selected-contact="selectedContact" />
  </div>
</template>
